import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/table.svg";
var TableSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  TableSolid_default as default
};
